import { CustomError } from "@utils/custom.error";

export class CalculatorError extends CustomError {
	public readonly message: string;
	public readonly fieldErrors: Record<string, string>;
	public readonly request: Record<string, any>;
	public readonly name = "CalculatorError";
	public readonly url: string;

	public constructor(
		message: string,
		fieldErrors?: Record<string, string>,
		request?: Record<string, any>,
		url?: string,
		needLog: boolean = true,
	) {
		super(message);

		this.message = message;
		this.fieldErrors = fieldErrors;
		this.request = request;
		this.url = url;
		this.needLog = needLog;
	}

	public getExtras(): Record<string, any> {
		return {
			fieldErrors: this.fieldErrors,
			request: this.request,
			url: this.url,
		};
	}
}
